import { Button, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { RadioGroup } from '@headlessui/react';
import { useParams } from 'react-router-dom';
import RopaService from '../../../../../services/Ropa.service';

export default function ModalSecret({
    open,
    secrets,
    handelClose,
    getRoPaDetailHeader,
    selected,
    setSelected,
}) {
    const { t } = useTranslation();
    const { activityId } = useParams();

    const handelOk = async () => {
        try {
            const payload = {
                activityId,
                secretLevelId: selected?.id,
            };
            const { data } = await RopaService.updateSecret(payload);
            if (data?.resultData) {
                handelClose();
                getRoPaDetailHeader();
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Modal
            width={450}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <div className="text-1xl">
                {t('RoPA.LevelOfConfidentiality')}{' '}
                <span className="text-[14px] text-[#ff4d4f] align-middle">
                    {' '}
                    *
                </span>
            </div>
            <div className="text-[#65707A]">
                {t('RoPA.SelectDataConfidentialityLevel')}
            </div>
            <div className="w-full px-4 py-6">
                <div className="mx-auto w-full max-w-md">
                    <RadioGroup value={selected} onChange={setSelected}>
                        <RadioGroup.Label className="sr-only">
                            {t('RR.Secrets')}
                        </RadioGroup.Label>
                        <div className="space-y-3">
                            {secrets?.map((secret) => (
                                <RadioGroup.Option
                                    key={secret.name}
                                    value={secret}
                                    style={{ border: '1px solid #DBDBDB' }}
                                    className={({ active, checked }) =>
                                        `${
                                            active
                                                ? 'ring-2 ring-white ring-opacity-60 ring-offset-1 ring-offset-[#7B67FB]'
                                                : ''
                                        }
                                        ${
                                            checked &&
                                            'ring-2 ring-white ring-opacity-60 ring-offset-1 ring-offset-[#7B67FB]'
                                        }
                                           relative flex cursor-pointer rounded-xl px-5 py-4 focus:outline-none`
                                    }
                                >
                                    {({ active, checked }) => (
                                        <>
                                            <div className="flex w-full items-center justify-between">
                                                <div className="flex items-center">
                                                    <div className="text-sm">
                                                        <RadioGroup.Label
                                                            as="div"
                                                            className="flex items-center space-x-4"
                                                        >
                                                            <span className="flex items-center">
                                                                {secret.icon}
                                                            </span>
                                                            <span>
                                                                {secret.name}
                                                            </span>
                                                        </RadioGroup.Label>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </RadioGroup.Option>
                            ))}
                        </div>
                    </RadioGroup>
                </div>
            </div>
            <div className="flex justify-center items-center space-x-4 pt-12">
                <Button
                    onClick={handelClose}
                    type="primary"
                    size="large"
                    ghost
                    className="w-[120px]"
                >
                    {t('common.Cancel')}
                </Button>
                <Button
                    onClick={handelOk}
                    htmlType="submit"
                    size="large"
                    type="primary"
                    className="w-[120px]"
                >
                    {t('common.Save')}
                </Button>
            </div>
        </Modal>
    );
}
